import React from 'react';
import PropTypes from 'prop-types';
import { upperCaseFirstLetter } from '../../../../Common/Utilities/StringUtilities';

class ImportCompletedView extends React.PureComponent
{
    render() {

        return (
            <div className="segment">
                <h2>{ `${upperCaseFirstLetter(this.props.nameOfObjectToImport)} import completed` }</h2>

                <p><strong>{ this.props.fileName }</strong> has been imported successfully.</p>

                <p>Would you like to:</p>

                <ul>
                    <li key="load more">
                        Load more { this.props.nameOfObjectToImport }? You can choose and import another { this.props.nameOfObjectToImport } file right away by selecting another { this.props.nameOfObjectToImport } file above.
                    </li>
                    <li key="just loaded">
                        <a target="_blank" rel="noopener noreferrer" href={ this.props.viewUrl }>{ this.props.postImportViewCaption }</a>
                    </li>
                    { this.props.notesOnCompletion }
                </ul>
            </div>
        );
    }

    static propTypes = {
        fileName: PropTypes.string.isRequired,
        nameOfObjectToImport: PropTypes.string.isRequired,
        notesOnCompletion: PropTypes.node.isRequired,
        viewUrl: PropTypes.string.isRequired
    }
}

export default ImportCompletedView;
